import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import { withRouter } from "react-router-dom";
import React from "react";
import Grid from "@material-ui/core/Grid";
import Helmet from "react-helmet";
import headersList from "Constants/headersList";
import CallOutNew from "Component/Headers/callOutNew";
import Switch from "@material-ui/core/Switch";
import { CheckActionPermission } from "Actions/commonAction";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";

import pageLayoutImg from "Assets/Svg/page-layout.svg";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Tooltip from "@material-ui/core/Tooltip";
import Dropzone from "react-dropzone";
import { floatinputconverter } from "Component/DynamicForm/Fields/Float";
import headerdummy from "Assets/Svg/default-header.svg";
import footerdummy from "Assets/Svg/default-footer.svg";
import PageHeader from "../../../../../../Component/Headers/pageHeader";
import uploadIcon from "../../../../../../Assets/newicons/action/upload/outline/upload-outline-16px.svg";
import DynamicForm from "../../../../../../Component/DynamicForm";
import { instance } from "../../../../../../Actions/AxiosInstance";
import ThumbnailBig from "../../../../../../Component/Thumbnail/ThumbnailRectangleBase64";
import { fileToBase64Link } from "../../../../../../Utils";
import { ErrorMessages } from "../../../../../../Constants";

class PageLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      leftMargin: null,
      rightMargin: null,
      topMargin: null,
      bottomMargin: null,
      isCustomLayout: false,
      defaultlayout: [],
      selectedLayout: null,
      postData: null,
      show: true,
      isdefault: true,
    };

    this.setMargins = this.setMargins.bind(this);
    this.uploadDoc = this.uploadDoc.bind(this);
    this.onDeleteDoc = this.onDeleteDoc.bind(this);
    this.setLayout = this.setLayout.bind(this);
    this.onSave = this.onSave.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("pagelayout");
    if (isTrue) {
      this.setState({ permissions }, () => {
        this.getPageData();
      });
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  handleChange(value, key) {
    // const { postData } = this.props;
    // postData[key] = value;
    // postData.isdefault = key == "isidentity" ? false : postData.isdefault;

    this.setState({
      [key]: value,
    });
  }

  getPageData() {
    instance
      .get("letter/getpagelayout")
      .then((result) => {
        const { pagelayout } = result.data.result[0];
        const { pagelayoutid } = pagelayout;
        const layouts = pagelayout.defaultlayout;
        const index = layouts.findIndex((x) => x.letterpagemarginid == 4);
        const selectedIndex = layouts.findIndex(
          (x) => x.letterpagemarginid == pagelayout.letterpagemarginid,
        );
        layouts[index].leftmargin =
          pagelayoutid && pagelayout.letterpagemarginid == 4
            ? pagelayout.leftmargin
            : null;
        layouts[index].rightmargin =
          pagelayoutid && pagelayout.letterpagemarginid == 4
            ? pagelayout.rightmargin
            : null;
        layouts[index].topmargin =
          pagelayoutid && pagelayout.letterpagemarginid == 4
            ? pagelayout.topmargin
            : null;
        layouts[index].bottommargin =
          pagelayoutid && pagelayout.letterpagemarginid == 4
            ? pagelayout.bottommargin
            : null;
        layouts[index].isselected =
          pagelayoutid && pagelayout.letterpagemarginid == 4
            ? pagelayout.isselected
            : false;
        layouts[index].unittypeid = 1;
        if (selectedIndex != -1) layouts[selectedIndex].unittypeid = 1;
        this.setState({
          postData: pagelayout,
          defaultlayout: layouts,
          isCustomLayout: pagelayout.letterpagemarginid == 4 ? true : false,
          selectedLayout: layouts[selectedIndex],
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          {
            variant: "error",
          },
        );
      });
  }

  onDeleteDoc(key) {
    const { postData } = this.state;
    postData[key] = null;
    this.setState({
      postData,
    });
  }

  async uploadDoc(key, files) {
    const file = files[0];
    const { postData } = this.state;
    const x = await fileToBase64Link(file);
    postData[key] = x;
    this.setState({
      postData,
    });
  }

  setMargins(key, value) {
    const { postData, selectedLayout } = this.state;
    postData[key] = value;
    selectedLayout[key] = value;
    this.setState({
      postData,
      selectedLayout,
    });
  }

  setLayout(id) {
    const { postData } = this.state;
    postData.letterpagemarginid = id;
    const obj = this.state.defaultlayout.find(
      (x) => x.letterpagemarginid == id,
    );
    this.setState(
      {
        show: false,
      },
      () => {
        this.setState({
          selectedLayout: obj,
          postData,
          isCustomLayout: id == 4 ? true : false,
          show: true,
        });
      },
    );
  }

  onSave() {
    const { postData, selectedLayout } = this.state;
    postData.ispagenumber = false;
    postData.unittypeid = selectedLayout.unittypeid;
    postData.leftmargin = selectedLayout.leftmargin;
    postData.rightmargin = selectedLayout.rightmargin;
    postData.topmargin = selectedLayout.topmargin;
    postData.bottommargin = selectedLayout.bottommargin;
    postData.pagemargintypeid = postData.letterpagemarginid;
    delete postData.defaultlayout;
    if (
      !postData.letterpagemarginid ||
      !postData.leftmargin ||
      !postData.rightmargin ||
      !postData.topmargin ||
      !postData.bottommargin
    ) {
      this.props.enqueueSnackbar(ErrorMessages.E0020, { variant: "error" });
      console.log("print err");
    } else if (
      (postData.header && !postData.footer) ||
      (!postData.header && postData.footer)
    ) {
      this.props.enqueueSnackbar(
        "Please select both header and footer or unselect both",
        { variant: "error" },
      );
    } else {
      instance
        .post("letter/configpagelayout", postData)
        .then(() => {
          this.props.enqueueSnackbar(ErrorMessages.E0000, {
            variant: "success",
          });
          this.getPageData();
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            {
              variant: "error",
            },
          );
        });
    }
  }

  render() {
    const { postData, isCustomLayout, selectedLayout, show } = this.state;
    console.log("selectedLayout: ", selectedLayout);
    return (
      <div className="content-outer-wrapper" style={{ marginBottom: 160 }}>
        <Helmet>
          <title>{headersList.Config.PageLayout.header}</title>
        </Helmet>
        {this.state.permissiondenied ? (
          <div className="position-rel">
            <PermissionDeniedComp />
          </div>
        ) : (
          <div>
            <Grid container>
              <Grid item xs={12} md={2} sm={2}>
                <p className="large-text-dark-secondary margin-bottom-8 t-bold">
                  Page Layout
                </p>
              </Grid>
              {/* <Grid
            item
            xs={12}
            md={10}
            sm={12}
            justify="flex-end"
            className="display-flex"
          >
            <div className="text-center">
              <Button
                color="primary"
                variant="contained"
                className="btn btn-primary-md-blue"
                onClick={this.onSave}
              >
                Save
              </Button>
            </div>
          </Grid> */}
            </Grid>
            <Grid container>
              <Grid item xs={12} md={6} sm={12}>
                <Grid
                  container
                  spacing={2}
                  className={this.state.isdefault ? "disable-appriciation" : ""}
                >
                  <Grid item xs={12} md={6} sm={12}>
                    <p className="normal-dark-secondary margin-bottom-8">
                      Upload header image
                    </p>

                    {postData && !postData.header ? (
                      <Tooltip title="Upload image" placement="top">
                        <Dropzone
                          onDrop={(e) => this.uploadDoc("header", e)}
                          multiple={false}
                          accept="image/*"
                          maxSize={2000000}
                          className="drag-drop"
                        >
                          <div className="uploader-wrapper cursor-pointer">
                            <div
                              className="vertical-center"
                              style={{ height: 20 }}
                            >
                              <img
                                src={uploadIcon}
                                className="vertical-middle"
                              ></img>
                              <span className="margin-left-16 small-blue">
                                Upload image
                              </span>
                            </div>
                          </div>
                        </Dropzone>
                      </Tooltip>
                    ) : (
                      <div className="pagelayout-file-uploader">
                        <ThumbnailBig
                          key="key"
                          onDelete={() => this.onDeleteDoc("header")}
                          onEdit={(file) => this.uploadDoc("header", file)}
                          filetypes="image/*"
                          doc={{
                            url:
                              postData && postData.header
                                ? postData.header
                                : "",
                          }}
                        />
                      </div>
                    )}
                  </Grid>
                  <Grid item xs={12} md={6} sm={12}>
                    <p className="normal-dark-secondary margin-bottom-8">
                      Upload footer image
                    </p>
                    {postData && !postData.footer ? (
                      <Tooltip title="Upload image" placement="top">
                        <Dropzone
                          onDrop={(e) => this.uploadDoc("footer", e)}
                          multiple={false}
                          accept="image/*"
                          maxSize={2000000}
                          className="drag-drop"
                        >
                          <div className="uploader-wrapper cursor-pointer">
                            <div
                              className="vertical-center"
                              style={{ height: 20 }}
                            >
                              <img
                                src={uploadIcon}
                                className="vertical-middle"
                              ></img>
                              <span className="margin-left-16 small-blue">
                                Upload image
                              </span>
                            </div>
                          </div>
                        </Dropzone>
                      </Tooltip>
                    ) : (
                      <div className="pagelayout-file-uploader">
                        <ThumbnailBig
                          key="key"
                          onDelete={() => this.onDeleteDoc("footer")}
                          onEdit={(e) => this.uploadDoc("footer", e)}
                          filetypes="image/*"
                          doc={{
                            url:
                              postData && postData.footer
                                ? postData.footer
                                : "",
                          }}
                        />
                      </div>
                    )}
                  </Grid>
                  {/* <p className="small-dark margin-top-16">
                📌
              </p> */}
                  <CallOutNew
                    classnames="bg-light-blue width100 display-flex margin-left-8"
                    header={
                      <span>
                        Upload photo with dimensions 1628x224px with max size 2 MB for optimum
                        results. (Supports .png, .jpeg and .svg file types)
                      </span>
                    }
                    emoji="📌"
                    textcolor="#1e8ced"
                  />
                </Grid>
                <div
                  className="display-flex margin-bottom-8 margin-top-16"
                  style={{ alignItems: "center" }}
                >
                  <Switch
                    checked={this.state.isdefault ? true : false}
                    onChange={(e) =>
                      this.handleChange(
                        e.target.value == "true" ? false : true,
                        "isdefault",
                      )
                    }
                    value={this.state.isdefault ? true : false}
                    // name={column}
                    color="primary"
                  />
                  <p className="normal-dark-secondary">
                    Preview sample header and footer
                  </p>
                </div>
                <p className="small-dark-secondary margin-bottom-8">
                  Note: Preview only for representational purpose.
                </p>

                <p className="normal-dark-secondary margin-bottom-8 margin-top-16">
                  Page margins
                </p>
                <Grid container>
                  <Grid
                    item
                    xs={12}
                    md={3}
                    sm={12}
                    onClick={() => this.setLayout(1)}
                    className={`page-margin-layout-outer cursor-pointer ${
                      selectedLayout &&
                      selectedLayout.letterpagemarginid == 1 &&
                      "selected-layout"
                    }`}
                  >
                    <div className="page-layout narrow-layout">
                      <div>
                        <div className="line1" style={{ top: 8 }}></div>
                        <div className="line2" style={{ right: 8 }}></div>
                        <div className="line3" style={{ bottom: 8 }}></div>
                        <div className="line4" style={{ left: 8 }}></div>
                      </div>
                    </div>
                    <p className="small-dark-secondary margin-top-16 text-align-center">
                      Narrow
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={3}
                    md={3}
                    sm={12}
                    onClick={() => this.setLayout(2)}
                    className={`page-margin-layout-outer cursor-pointer ${
                      selectedLayout &&
                      selectedLayout.letterpagemarginid == 2 &&
                      "selected-layout"
                    }`}
                  >
                    <div className="page-layout">
                      <div>
                        <div className="line1" style={{ top: 12 }}></div>
                        <div className="line2" style={{ right: 12 }}></div>
                        <div className="line3" style={{ bottom: 12 }}></div>
                        <div className="line4" style={{ left: 12 }}></div>
                      </div>
                    </div>
                    <p className="small-dark-secondary margin-top-16 text-align-center">
                      Moderate
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={3}
                    sm={12}
                    onClick={() => this.setLayout(3)}
                    className={`page-margin-layout-outer cursor-pointer ${
                      selectedLayout &&
                      selectedLayout.letterpagemarginid == 3 &&
                      "selected-layout"
                    }`}
                  >
                    <div className="page-layout">
                      <div>
                        <div className="line1" style={{ top: 16 }}></div>
                        <div className="line2" style={{ right: 16 }}></div>
                        <div className="line3" style={{ bottom: 16 }}></div>
                        <div className="line4" style={{ left: 16 }}></div>
                      </div>
                    </div>
                    <p className="small-dark-secondary margin-top-16 text-align-center">
                      Wide
                    </p>
                  </Grid>
                  {/* <Grid
                item
                xs={12}
                md={3}
                sm={12}
                onClick={() => this.setLayout(4)}
                className={`page-margin-layout-outer cursor-pointer ${selectedLayout
                  && selectedLayout.letterpagemarginid == 4
                  && "selected-layout"}`}
              >
                <div className="page-layout"></div>
                <p className="small-dark-secondary margin-top-16 text-align-center">Custom</p>
              </Grid> */}
                </Grid>
                {show && (
                  <div
                    style={{
                      position: "relative",
                      textAlign: "center",
                      width: 200,
                      left: 32,
                      marginTop: 20,
                    }}
                  >
                    <p
                      style={{ position: "absolute", top: 0, width: "100%" }}
                      className="small-dark-secondary"
                    >
                      T{" "}
                      <strong>
                        {" "}
                        {selectedLayout ? selectedLayout.topmargin : 0}cm{" "}
                      </strong>
                    </p>
                    <img
                      src={pageLayoutImg}
                      style={{
                        position: "absolute",
                        top: 32,
                        left: 0,
                        right: 0,
                        margin: "0 auto",
                      }}
                    ></img>
                    <p
                      className="small-dark-secondary"
                      style={{ position: "absolute", top: 162, width: "100%" }}
                    >
                      B{" "}
                      <strong>
                        {" "}
                        {selectedLayout
                          ? selectedLayout.bottommargin
                          : 0}cm{" "}
                      </strong>
                    </p>
                    <p
                      className="small-dark-secondary"
                      style={{
                        position: "absolute",
                        top: 80,
                        right: -24,
                        height: "100%",
                      }}
                    >
                      R{" "}
                      <strong>
                        {" "}
                        {selectedLayout ? selectedLayout.rightmargin : 0}cm{" "}
                      </strong>
                    </p>
                    <p
                      className="small-dark-secondary"
                      style={{
                        position: "absolute",
                        top: 80,
                        left: -24,
                        height: "100%",
                      }}
                    >
                      L{" "}
                      <strong>
                        {" "}
                        {selectedLayout ? selectedLayout.leftmargin : 0}cm{" "}
                      </strong>
                    </p>
                  </div>
                )}
                {/* {show && (
              <Grid container spacing={2} className="margin-top-24">
                <Grid item xs={12} md={4} sm={12}>
                  <DynamicForm
                    fields={floatinputconverter({
                      disabled: !isCustomLayout,
                      value: selectedLayout && selectedLayout.leftmargin,
                      label: "Left",
                      placeholder: "",
                      max: 3,
                    })}
                    onChange={(val) => this.setMargins("leftmargin", val)}
                  />
                </Grid>
                <Grid item xs={12} md={4} sm={12}>
                  <DynamicForm
                    fields={floatinputconverter({
                      disabled: !isCustomLayout,
                      value: selectedLayout && selectedLayout.rightmargin,
                      label: "Right",
                      placeholder: "",
                      max: 3,
                    })}
                    onChange={(val) => this.setMargins("rightmargin", val)}
                  />
                </Grid>
                <Grid item xs={12} md={4} sm={12}>
                  <div>
                    <div className="input-label">Unit</div>
                    <div style={{ marginTop: 9 }}>cm</div>
                  </div>
                </Grid>
                <Grid item xs={12} md={4} sm={12}>
                  <DynamicForm
                    fields={floatinputconverter({
                      disabled: !isCustomLayout,
                      value: selectedLayout && selectedLayout.topmargin,
                      label: "Top",
                      placeholder: "",
                      max: 3,
                    })}
                    onChange={(val) => this.setMargins("topmargin", val)}
                  />
                </Grid>
                <Grid item xs={12} md={4} sm={12}>
                  <DynamicForm
                    fields={floatinputconverter({
                      disabled: !isCustomLayout,
                      value: selectedLayout && selectedLayout.bottommargin,
                      label: "Bottom",
                      placeholder: "",
                      max: 3,
                    })}
                    onChange={(val) => this.setMargins("bottommargin", val)}
                  />
                </Grid>
              </Grid>
            )} */}
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
                sm={12}
                justify="flex-end"
                className="display-flex"
              >
                <Paper
                  className="rounded-rectangle-paper position-rel"
                  style={{ width: 400, height: 566 }}
                >
                  {/* {postData && postData.header && ( */}
                  <div className="header-img">
                    <img
                      src={this.state.isdefault ? headerdummy : postData.header}
                      width="100%"
                      style={{ maxHeight: 54 }}
                    ></img>
                  </div>
                  {/* )} */}

                  <div
                    className="previewline1"
                    style={{
                      top:
                        selectedLayout && selectedLayout.topmargin
                          ? selectedLayout.topmargin * 18.89
                          : "0",
                      opacity: postData && postData.header ? "0" : "1",
                    }}
                  ></div>

                  <div
                    className="previewline2"
                    style={{
                      right:
                        selectedLayout && selectedLayout.rightmargin
                          ? selectedLayout.rightmargin * 18.89
                          : "0",
                    }}
                  ></div>
                  <div
                    className="previewline3"
                    style={{
                      bottom:
                        selectedLayout && selectedLayout.bottommargin
                          ? selectedLayout.bottommargin * 18.89
                          : "0",
                      opacity: postData && postData.footer ? "0" : "1",
                    }}
                  ></div>
                  <div
                    className="previewline4"
                    style={{
                      left:
                        selectedLayout && selectedLayout.leftmargin
                          ? selectedLayout.leftmargin * 18.89
                          : "0",
                    }}
                  ></div>

                  {/* {postData && postData.footer && ( */}
                  <div className="footer-img">
                    <img
                      src={this.state.isdefault ? footerdummy : postData.footer}
                      width="100%"
                      // height="40"
                      style={{ maxHeight: 54 }}
                    ></img>
                  </div>
                  {/* )} */}
                </Paper>
              </Grid>
            </Grid>
            <div
              className="width100"
              style={{
                position: "fixed",
                left: 0,
                background: "white",
                bottom: 0,
                padding: 10,
                borderTop: "1px solid #d4d4d4",
                zIndex: 1,
              }}
            >
              <div>
                <div className="floatright" style={{ marginRight: 72 }}>
                  <div>
                    <Button
                      color="primary"
                      variant="contained"
                      className={
                        this.state.isdefault
                          ? "btn btn-primary-md-grey"
                          : "btn btn-primary-md-blue"
                      }
                      onClick={this.onSave}
                      disabled={this.state.isdefault ? true : false}
                    >
                      Save
                    </Button>
                  </div>
                </div>
                <div className="clearfloat"></div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(withStyles()(withSnackbar(PageLayout)));
